/**
 * Created by Ivan on 31.01.2025
 */

const BonusLevelComponent = cc.Node.extend({
    ctor: function (coinsAmount) {
        this._super();

        this.coinsAmount = coinsAmount;

        this.reward = new Reward("hard", this.coinsAmount, {
            event: cleverapps.EVENTS.EARN.BONUS_LEVEL_REWARD
        });
        this.reward.receiveReward();
        cleverapps.dataLoader.processSaveQueue();

        this.setAnchorPoint(0.5, 0.5);

        const chestPath = bundles.bonus_level.jsons.bonus_chest_horizontal_json;
        const chest = this.chest = new cleverapps.Spine(chestPath);

        this.addChild(chest);
        chest.setAnimation(0, "animation", true);
        chest.setVisible(false);
        cleverapps.UI.wrap(this);
    },

    showUp: function () {
        this.chest.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            StandartAnimations.showUp(this.chest, { flash: true })
        ));
    },

    receiveRewards: function (f) {
        if (this.coinsAmount) {
            this.chest.runAction(new cc.Sequence(
                new cc.CallFunc(() => {
                    this.chest.setAnimation(0, "open", false);
                }),
                new cc.DelayTime(0.8),
                StandartAnimations.coinCloud(this, {
                    reward: this.coinsAmount
                }),
                new cc.DelayTime(0.8),
                new cc.CallFunc(() => {
                    this.reward.updateViewAmount();
                }),
                new cc.ScaleTo(0.3, 0.2),
                new cc.RemoveSelf(),
                new cc.CallFunc(f)
            ));
        } else {
            this.removeFromParent();
            f();
        }
    }
});